import React from 'react';
import { useSelector } from 'react-redux';
import { Field } from 'react-final-form';

import { useParams } from 'react-router';

import { FeedbackRecognitionTemplateTypes } from 'Shared/constants/types';

import FeedbackFormSection from '../FeedbackFormSection/FeedbackFormSection';
import { getWorkspaceTeammate } from 'Shared/selectors/workspace';
import { Map, fromJS } from 'immutable';
import FeedbackFromReviewTemplateQuestions from './FeedbackFromReviewTemplateQuestions';

type Props = {
  reviewTemplateSlug: string;
};

//Hooks
import { useReviewTemplate } from 'Shared/utils/hooks/use-review-template';

function FeedbackFromReviewTemplateTemplate({ reviewTemplateSlug }: Props) {
  const { isFetching, template } = useReviewTemplate({ slug: reviewTemplateSlug });

  const { workspaceId } = useParams();
  const receiverSlug = useSelector(state => getWorkspaceTeammate(workspaceId)(state)?.slug);

  if (isFetching || !template) return null;

  const feedbackReviewFormTemplate = Map(fromJS(template.reviewFormTemplates[0]));

  return (
    <FeedbackFormSection
      showRequestFeedback={false}
      templateType={FeedbackRecognitionTemplateTypes.feedbackfromReviewTemplateTemplate}
    >
      <Field
        name="answers"
        component={FeedbackFromReviewTemplateQuestions}
        feedbackReviewFormTemplate={feedbackReviewFormTemplate}
        receiverSlug={receiverSlug}
      />
    </FeedbackFormSection>
  );
}

export default FeedbackFromReviewTemplateTemplate;
